import { Card, CardBody, Col, Table } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { GridOptions } from "../../../../Constant";
import { GRID_DATA } from "../../../../Data/UiKit/Grid";
import { GridOptionTableBody } from "./GridOptionTableBody";
import { GridOptionTableHead } from "./GridOptionTableHead";

const GridOptionsCart = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={GridOptions} span={GRID_DATA} />
        <CardBody>
          <div className="table-responsive theme-scrollbar">
            <Table bordered striped>
              <GridOptionTableHead />
              <GridOptionTableBody />
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default GridOptionsCart;
